<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t('goals.goalValues') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form ref="addHistory" lazy-validation>
              <v-card-text class="black--text">
                <v-row v-for="(item, index) in goalHistoryForm" :key="index">
                  <v-col cols="12">
                    <label>{{ $t('goals.goalEndDate') }}</label>
                    <v-menu
                      :ref="goalEndDateMenu[index]"
                      v-model="goalEndDateMenu[index]"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.goalEndDate"
                          persistent-hint
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          @blur="date = parseDate(item.goalEndDate)"
                          v-on="on"
                          v-on:click:prepend-inner="pickDate(index)"
                          outlined
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.goalEndDate"
                        no-title
                        @input="goalEndDateMenu[index] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <label>{{ $t('goals.baseValue') }}</label>
                    <v-text-field
                      :placeholder="$t('goals.typeValueHere')"
                      v-model.number="item.baseValueHistory"
                      outlined
                      hide-details
                      dense
                      :rules="goalRules.baseValue"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <label>{{ $t('goals.finalValue') }}</label>
                    <v-text-field
                    :placeholder="$t('goals.typeValueHere')"
                      v-model.number="item.finalValueHistory"
                      outlined
                      hide-details
                      dense
                      :rules="goalRules.targetValue"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="text-right" v-if="index >= 0">
                    <v-btn depressed class="red--text" @click="removeGoalHistory(index)">
                      {{ $t('remove') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-btn
                      depressed
                      style="background: #E5F8F1; color: #00BD73;height: 54px; text-transform: none;"
                      @click="addGoalHistory"
                    >
                      {{ $t('goals.anotherGoalHistory') }}
                      <img src="/img/Group 7148.svg" />
                    </v-btn>
                  </v-col>
                </v-row>

                <v-divider class="mt-5"></v-divider>
                <v-card-actions class="mt-10" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                    @click="closeModal"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn right height="44" width="116" color="primary" @click="saveGoalHistory">
                    {{ $t("save") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import { goalRules } from "@/validations/AddGoalsRules.js"

export default {
  name: 'GoalHistoryDialog',
  data() {
    return {
      goalHistoryForm: [{
        goalEndDate: null,
        baseValueHistory: null,
        finalValueHistory: null
      }],
      goalEndDateMenu: [],
      goalRules,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    goalHistoryProp: {
      type: Array,
      required: false
    }
  },
  created () {
    if (this.goalHistoryProp && this.goalHistoryProp.length > 0) {
      this.goalHistoryForm = this.goalHistoryProp
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeGoalHistoryDialog")
      this.resetGoalHistoryForm()
    },
    saveGoalHistory () {
      if (!this.$refs.addHistory.validate()) return;
      this.$emit('emitGoalHistory', this.goalHistoryForm)
      this.$emit("closeGoalHistoryDialog");
    },
    resetGoalHistoryForm () {
      this.goalHistoryForm = [{
        goalEndDate: null,
        baseValueHistory: null,
        finalValueHistory: null
      }]
    },
    addGoalHistory () {
      this.goalHistoryForm.push({
        goalEndDate: null,
        baseValueHistory: null,
        finalValueHistory: null
      })
    },
    removeGoalHistory (index) {
      this.goalHistoryForm = this.goalHistoryForm.filter((item, idx) => idx !== index )
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    pickDate(index) {
        this.goalEndDateMenu.push();
        this.goalEndDateMenu[index] = true;
    }
  },
};
</script>

<style></style>
